<template>
  <div class="logic-text-component" @click.stop.prevent :style="getTextStyle">
    <div
      :id="'logicTextContent-' + myid.container_id + '-' + myid.rect_id"
      class="content textInner"
      v-if="options.animateSets.animateType === 0 || options.animateSets.animateClass != ''"
      :ref="'textInner'"
      :class="options.contentHasLimit ? 'overflowHidMultiLine' : ''"
      :style="getTextColor"
      @click.stop="textClickEvent"
      :contenteditable="isEditStatu"
      v-html="initDom"
      @dblclick.stop="dbEditContent($event)"
      @blur="dbChangeContent($event)"
    ></div>
    <svg
      v-else-if="
        options.animateSets.animateType === 1 &&
        (options.animateSets.animateDirection === '横向' || options.animateSets.animateDirection === '无')
      "
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs v-show="options.colorType === '线性渐变'">
        <linearGradient id="g3" x1="0%" y1="0%" x2=" 100%" y2="0">
          <stop offset="0%" :stop-color="options.endColor"></stop>
          <stop offset="100%" :stop-color="options.startColor"></stop>
        </linearGradient>
      </defs>
      <rect v-show="options.colorType === '线性渐变'" width="100" height="100%" x="0" y="100%" fill="url(#g3)"></rect>
      <text>
        <tspan
          class="content"
          y="65%"
          font-weight="normal"
          :class="options.contentHasLimit ? 'overflowHidMultiLine' : ''"
          :style="'-webkit-line-clamp:' + options.textLimitLines"
          @click="textClickEvent"
          :fill="options.colorType === '线性渐变' ? 'url(#g3)' : options.color"
        >
          {{ editContent }}
        </tspan>
        <animate
          attributeName="x"
          :dur="options.animateSets.animateDuration + options.animateSets.animateDelay + 's'"
          :keyTimes="keyTimes"
          values="100%;0;0;-100%"
          :repeatCount="options.animateSets.animateTriggerNumType === '单次触发' ? '' : 'indefinite'"
        ></animate>
      </text>
    </svg>
    <svg
      v-if="options.animateSets.animateType === 1 && options.animateSets.animateDirection === '纵向'"
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs v-show="options.colorType === '线性渐变'">
        <linearGradient id="g3" x1="0%" y1="0%" x2=" 100%" y2="0">
          <stop offset="0%" :stop-color="options.endColor"></stop>
          <stop offset="100%" :stop-color="options.startColor"></stop>
        </linearGradient>
      </defs>
      <rect v-show="options.colorType === '线性渐变'" width="100" height="100%" x="0" y="100%" fill="url(#g3)"></rect>
      <text y="65%">
        <tspan
          class="content"
          font-weight="normal"
          :class="options.contentHasLimit ? 'overflowHidMultiLine' : ''"
          :style="'-webkit-line-clamp:' + options.textLimitLines"
          @click="textClickEvent"
          :fill="options.colorType === '线性渐变' ? 'url(#g3)' : options.color"
        >
          {{ editContent }}
        </tspan>
        <animate
          attributeName="y"
          :dur="options.animateSets.animateDuration + options.animateSets.animateDelay + 's'"
          :keyTimes="keyTimes"
          values="-110%;0;0;100%"
          :repeatCount="options.animateSets.animateTriggerNumType === '单次触发' ? '' : 'indefinite'"
        ></animate>
      </text>
    </svg>
    <div v-show="showSettingDialog" class="setDynamic_dialog" :style="settingDialogPosition">
      <cx-tooltip content="设为变量" class="item">
        <span class="variable_btn" @mousedown.stop="setVariableHandle" @click.stop></span>
      </cx-tooltip>
      <cx-tooltip content="设为动态数据" class="item">
        <span class="dynamic_btn" @mousedown.stop="setDynamicHandle" @click.stop></span>
      </cx-tooltip>
    </div>
    <div v-show="variableParams.isShow" class="variable_dialog" :style="variableParams.style">
      <span class="icon-portal-variable mr2 fs14"></span>
      <span class="fs14 mr4">{{ variableParams.name }}</span>
      <span class="icon-portal-setting1 fs14 setting-btn" @click="variableToolBoxClick"></span>
    </div>
    <div v-show="dynamicParams.isShow" class="dynamic_dialog" :style="dynamicParams.style">
      <span class="icon-portal-dynamic-data fs14 mr2"></span>
      <span class="mr4">{{ dynamicParams.name }}</span>
      <span class="icon-portal-detach fs14 detach-btn" @click="dynamicToolBoxClick"></span>
    </div>
  </div>
</template>

<script>
import { v1 } from "uuid"
const uuid = { v1 }
import { listenNode } from "utils/listener"
import { isSsrPage, spliceLinkUrl } from "utils/index"
import { parseDOM, parseAST } from "utils/parseDomAst/index"
import $ from "jquery"
import eventMixin from "utils/event/eventMixin.js"
import {compareIds} from "utils/event/animate";
export default {
  mixins: [eventMixin],
  name: "cxtext",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    },
    active:{
      type:Boolean
    }
  },
  data() {
    return {
      reloadTimer: null,
      isEditStatu: false,
      activeIds: undefined,
      showSettingDialog: false,
      settingDialogPosition: {
        left: 0,
        top: 0
      },
      selectText: "",
      initDom: "", // 初始化dom内容
      showVariableDialog: false,
      variableDialogStyle: {
        left: 0,
        top: 0
      },
      variableName: "变量1",
      showDynamicDialog: false,
      variableParams: {
        isShow: false,
        name: "",
        id: "",
        style: {
          left: 0,
          top: 0
        }
      },
      dynamicParams: {
        isShow: false,
        name: "",
        id: "",
        style: {
          left: 0,
          top: 0
        }
      },
      dynamicDialogStyle: {
        left: 0,
        top: 0
      },
      dynamicName: "动态数据1",
      variableDomList: [],
      dynamicDomList: [],
    }
  },
  watch: {
    "ids":{
      deep:true,
      handler(n,o) {
        if(!compareIds(n,this.myid)){
          // 去除选中状态
          this.variableParams.isShow = false
          this.dynamicParams.isShow = false
          Array.from(document.getElementsByClassName("dynamicContent")).forEach(item => {
            item.style.background = ""
          })
          Array.from(document.getElementsByClassName("variableContent")).forEach(item => {
            item.style.background = ""
          })
          if (this.isEditStatu) {
            this.dbChangeContent()
          }
        }
      }
    },
    initDom: function () {
      this.$nextTick(function () {
        this.initRichTextEventHandle()
      })
    },
    // active:(newVal,oldVal)=>{
    //   if(!newVal && this){
    //     if (document.getElementById(this.logicTextDynamicId+'')) {
    //       document.getElementById(this.logicTextDynamicId+'').style.background = ""
    //     }
    //   }
    // },
    // logicTextDynamicId: function (newVal, oldVal) {
    //   if (newVal !== oldVal) {
    //     this.$nextTick(function () {
    //       if (document.getElementById(oldVal)) {
    //         document.getElementById(oldVal).style.background = ""
    //       }
    //       document.getElementById(oldVal + "-dialog")?.remove()
    //     })
    //   }
    // }
  },
  mounted() {
    // if (this.ids.container_id !== this.myid.container_id) return
    if (this.$refs.textInner) {
      this.$refs.textInner.style.transform = "rotate(" + this.options.rotate + "deg)"
    }
    this.updateData()
    if (this.isBigScreenPreview() && this.options.autoUpdate !== false) {
      this.reloadTimer = setInterval(() => this.updateData(), this.updateTimer)
    }
    this.initRichTextContentHandle()
    this.initTextSelectHandle()
  },
  beforeDestroy() {
    document.removeEventListener("selectionchange", this.onSelectionChange)
    this.variableDomList.forEach(([dom, listener]) => {
      dom.removeEventListener("click", listener)
    })
    this.dynamicDomList.forEach(([dom, listener]) => {
      dom.removeEventListener("click", listener)
    })
    clearInterval(this.reloadTimer)
    this.reloadTimer = null
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    logicTextDynamicId() {
      return this.$store.state.states.logicTextDynamicId
    },
    editContent() {
      let content = this.getTextContent.replace(/<[^>]+>/g, "")
      return content
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    keyTimes() {
      let stopStartTime, stopEndTime
      let t =
        this.options.animateSets.animateDelay /
        (this.options.animateSets.animateDuration + this.options.animateSets.animateDelay)
      stopStartTime = (1 - t) / 2
      stopEndTime = stopStartTime + t
      return "0;" + stopStartTime.toFixed(2) + ";" + stopEndTime.toFixed(2) + ";1"
    },
    bgColor() {
      switch (this.options.bgType) {
        case "主题色":
          return isSsrPage()
            ? this.$store.state.page.themeColor
            : this.$store.state[this.request_prefix].page.themeColor
        case "自定义":
          return this.options.bgColor
      }
    },
    hoverBgColor() {
      switch (this.options.hoverBgType) {
        case "主题色":
          return isSsrPage()
            ? this.$store.state.page.themeColor
            : this.$store.state[this.request_prefix].page.themeColor
        case "自定义":
          return this.options.hoverBgColor
      }
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      if (!this.options.background || !Array.isArray(this.options.background)) {
        return {}
      }
      this.options.background.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    getTextColor() {
      let colorStyle = {}
      if (this.options.colorType === "线性渐变") {
        colorStyle = {
          color: "transparent",
          backgroundImage: `-webkit-linear-gradient(${this.options.colorlinearGradientAngle}deg, ${this.options.startColor}, ${this.options.endColor})`,
          // background: "-webkit-linear-gradient(top, #FF0000, #00FF00)",
          "-webkit-background-clip": "text",
          "-webkit-line-clamp": this.options.textLimitLines
        }
      } else {
        colorStyle = {
          // color: this.options.textIsThemeColor ? this.themeColor : this.options.color,
          color: this.$parseColor(this.options.color, {
            isThemeColor: this.options.textIsThemeColor
          }),
          "-webkit-line-clamp": this.options.textLimitLines
        }
      }
      return colorStyle
    },
    boxShadowStyle() {
      let tmpStyle = ""
      if (Array.isArray(this.options.boxShadowH) && this.options.boxShadowH.length > 0) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${this.options.boxShadowH[index]}px ${this.options.boxShadowV[index]}px ${this.options.boxShadowBlur[index]}px ${this.options.boxShadowSpread[index]}px ${this.$parseColor(this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    getTextStyle() {
      let borderW = ""
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      if (this.$refs.textInner) {
        this.$refs.textInner.style.transform = "rotate(" + this.options.rotate + "deg)"
        // this.$refs.textInner.style.background = this.bgColor
      }
      const lineHeight = this.options.lineHeightType === '%' ? (this.options.lineHeight / 100) :
          this.options.lineHeightType === 'normal'? "normal" :this.options.lineHeight + "px"
      return {
        ...this.bgStyle,
        "font-style": this.options.fontStyle,
        // width: this.options.width + "px",
        width: "100%",
        height: "100%",
        // height: this.options.height + "px",
        "font-Family": this.options.fontFamily,
        "text-indent": this.options.textIndent,
        "font-size": this.options.fontSize + "px",
        "font-weight": this.options.fontWeight,
        // "line-height": this.options.lineHeight + "px",
        "line-height": lineHeight,
        "text-align": this.options.textAlign,
        "writing-mode": this.options.writingMode,
        // "letter-spacing": this.options.letterSpacing + "px",
        "letter-spacing":
          this.options.letterSpacingType === "%"
            ? this.options.letterSpacing / 100 + "em"
            : this.options.letterSpacing + "px",
        "text-decoration": this.options.textDecoration,
        "text-decoration-color": this.options.color,
        top: this.options.top,
        left: this.options.left,
        "z-index": this.options.zIndex,
        padding: this.options.padding + "px",
        paddingTop: this.options.paddingTop + "px",
        paddingRight: this.options.paddingRight + "px",
        paddingBottom: this.options.paddingBottom + "px",
        paddingLeft: this.options.paddingLeft + "px",
        // "border-radius": this.options.borderRadius + "px",
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
        "border-style": this.options.borderStyle,
        // "border-color": this.options.borderIsThemeColor
        //   ? this.themeColor
        //   : this.options.borderColor && this.options.borderColor.color
        //   ? this.options.borderColor.color
        //   : this.options.borderColor,
        "border-color": this.$parseColor(this.options.borderColor, {
          isThemeColor: this.options.borderIsThemeColor
        }),
        "border-width": borderW,
        overflow: this.options.textOverFlowType,
        opacity: this.options.opacity / 100,
        "box-shadow": this.boxShadowStyle
        // overflow: "auto"
      }
    },
    updateTimer() {
      if (!this.options.updateTimer) {
        this.$changeOptionsEV(600, "updateTimer", false, false, false, true)
        return 600 * 1000
      }
      return this.options.updateTimer * 1000
    },
    restDataUrl() {
      return this.options.restDataUrl
    },
    fieldList() {
      return this.options.fieldList
    }
  },
  methods: {
    async updateData() {
      this.updateNormalRect.call(
        this,
        datas => {
          this.content = datas[0][Object.keys(datas[0])[0]].value
          const data = datas[0]
          let fieldList = []
          Object.keys(data).map((key, item) => {
            console.log(key, data[key])
            if (Object.prototype.toString.call(data[key]) === "[object Object]") {
              // 判断是否为Object
              const param = {
                label: data[key].key,
                value: data[key].value
              }
              fieldList.push(param)
            }
          })
          this.$changeOptionsEV(fieldList, "fieldList", false, undefined, this.myid, true)
        },
        1
      )
    },
    textClickEvent: function () {
      const spliceUrl = spliceLinkUrl(this)
      if (this.options.linkUrl && process.env.NODE_ENV !== "development") {
        window.open(spliceUrl || this.options.linkUrl, this.options.openBlankPage ? "_blank" : "")
      }
    },
    dbEditContent() {
      this.isEditStatu = true
      sessionStorage.setItem("isEditStatu", true)
      this.activeIds = JSON.parse(JSON.stringify(this.ids))
      this.$store.commit(this.request_prefix + "/CHANGE_DRAGGABLE", { ...this.myid, flag: false })
      this.$nextTick(() => {
        this.getSelectPos()
      })
    },
    // 将光标移动到最后面
    getSelectPos() {
      let esrc = this.$refs.textInner
      let range = document.createRange()
      range.selectNodeContents(esrc)
      range.collapse(false)
      let sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(range)
    },
    dbChangeContent(event) {
      this.isEditStatu = false
      sessionStorage.removeItem("isEditStatu")
      this.$store.commit(this.request_prefix + "/CHANGE_DRAGGABLE", { ...this.myid, flag: true })
      this.initDom = event.target.innerHTML
      this.showSettingDialog = false
      // window.getSelection().getRangeAt(0).collapse(true)
    },
    // 初始化文本选中事件
    initTextSelectHandle() {
      document.addEventListener("selectionchange", this.onSelectionChange)
    },
    // 初始化接口数据
    initInterfaceData(variableData) {
      let value = null
      if (!!variableData.field && this.fieldList.length > 0) {
        value = this.fieldList.filter(item => item.label === variableData.field)[0]?.value
      }
      if (!!variableData.variableValue) {
        // 替换变量
        if (value === null) {
          if (!!document.getElementById(variableData.variableValue)) {
            value = document.getElementById(variableData.variableValue).innerHTML
          }
        } else {
          document.getElementById(variableData.variableValue).innerHTML = value
        }
        // 根据条件替换动态数据
        if (variableData.conditionList.length > 0) {
          for (let i = 0; i < variableData.conditionList.length; i++) {
            const conditionItem = variableData.conditionList[i]
            if (!conditionItem.result || !conditionItem.dynamicValue) return
            const dom = parseDOM(conditionItem.result)
            if (conditionItem.type === "singleValue") {
              switch (conditionItem.condition) {
                case "等于":
                  if (value === conditionItem.parameter) {
                    document.getElementById(conditionItem.dynamicValue).innerHTML = dom.innerHTML
                  }
                  break
                case "不等于":
                  if (value !== conditionItem.parameter) {
                    document.getElementById(conditionItem.dynamicValue).innerHTML = dom.innerHTML
                  }
                  break
                case "包含":
                  if (value.indexOf(conditionItem.parameter) !== -1) {
                    document.getElementById(conditionItem.dynamicValue).innerHTML = dom.innerHTML
                  }
                  break
                case "不包含":
                  if (value.indexOf(conditionItem.parameter) === -1) {
                    document.getElementById(conditionItem.dynamicValue).innerHTML = dom.innerHTML
                  }
                  break
                case "大于":
                  if (Number(value) > Number(conditionItem.parameter)) {
                    document.getElementById(conditionItem.dynamicValue).innerHTML = dom.innerHTML
                  }
                  break
                case "小于":
                  if (Number(value) < Number(conditionItem.parameter)) {
                    document.getElementById(conditionItem.dynamicValue).innerHTML = dom.innerHTML
                  }
                  break
                case "为空":
                  if (!!!value) {
                    document.getElementById(conditionItem.dynamicValue).innerHTML = dom.innerHTML
                  }
                  break
                case "不为空":
                  if (!!value) {
                    document.getElementById(conditionItem.dynamicValue).innerHTML = dom.innerHTML
                  }
                  break
              }
            } else {
              if (
                Number(value) >= Number(conditionItem.conditionRange[0]) &&
                Number(value) <= Number(conditionItem.conditionRange[1])
              ) {
                document.getElementById(conditionItem.dynamicValue).innerHTML = dom.innerHTML
              }
            }
          }
        }
      }
    },
    // 根据特殊条件隐藏对应画布
    initSpecialCondition(specialCondition) {
      switch (specialCondition.condition) {
        case "等于":
          if (document.getElementById(specialCondition.variableValue).innerHTML === specialCondition.parameter) {
            console.log("等于")
            console.log("in", this.myid)
            document.getElementById("container_" + this.myid.container_id).style.display = "none"
          }
          break
        case "不等于":
          if (document.getElementById(specialCondition.variableValue).innerHTML !== specialCondition.parameter) {
            console.log("不等于")
          }
          break
        case "包含":
          if (
            document.getElementById(specialCondition.variableValue).innerHTML.indexOf(specialCondition.parameter) !== -1
          ) {
            console.log("包含")
          }
          break
        case "不包含":
          if (
            document.getElementById(specialCondition.variableValue).innerHTML.indexOf(specialCondition.parameter) === -1
          ) {
            console.log("不包含")
          }
          break
        case "大于":
          if (
            Number(document.getElementById(specialCondition.variableValue).innerHTML) >
            Number(specialCondition.parameter)
          ) {
            console.log("大于")
          }
          break
        case "小于":
          if (
            Number(document.getElementById(specialCondition.variableValue).innerHTML) <
            Number(specialCondition.parameter)
          ) {
            console.log("小于")
          }
          break
      }
    },
    // 设为变量事件
    setVariableHandle() {
      const variableId = "variable-" + uuid.v1()
      let suffix = this.options.variableDataList.reduce((max, item) => {
        const num = Number(item.variableLabel.replace(/[^0-9]/ig, ""))
        return num > max ? num : max
      }, 0)
      let variableData = {
        field: "", // 字段名称
        variableLabel: "变量" + (suffix + 1), // 变量名
        variableValue: variableId, // 变量唯一标识
        conditionList: [
          // 条件设置
          {
            type: "single",
            conditionRange: [0, 10],
            condition: "等于", // 条件  等于；不等于；包含；不包含；大于；小于
            dynamicLabel: "", // 动态数据名
            dynamicValue: "", // 动态数据唯一标识
            parameter: "", // 参数值
            result: "" // 结果
          }
        ]
      }
      const sel = window.getSelection && window.getSelection()
      if (sel && sel.rangeCount > 0) {
        const range = sel.getRangeAt(0)
        const selectedText = range.extractContents()
        const span = $(
          `<span name="${variableData.variableLabel}" id="${variableId}" class="variableContent variableContentBorder">${selectedText.textContent}</span>`
        )
        range.insertNode(span[0])
        this.clearSelection()
      }
      let variableDataListTemp = JSON.parse(JSON.stringify(this.options.variableDataList))
      variableDataListTemp.push(variableData)
      this.$changeOptionsEV(variableDataListTemp, "variableDataList", false, undefined, this.myid, true)
      this.showSettingDialog = false
    },
    // 设为动态数据事件
    setDynamicHandle() {
      const dynamicId = "dynamic-" + uuid.v1()
      // 遍历this.options.dynamicList，找到其中名称后缀最大值
      let suffix = this.options.dynamicList.reduce((max, item) => {
        const num = Number(item.label.replace(/[^0-9]/ig, ""))
        return num > max ? num : max
      }, 0)
      let dynamicData = {
        label: "动态数据" + (suffix + 1), // 动态数据名称
        value: dynamicId
      }
      const sel = window.getSelection && window.getSelection()
      if (sel && sel.rangeCount > 0) {
        const range = sel.getRangeAt(0)
        const selectedText = range.extractContents()
        const span = $(
          `<span name="${dynamicData.label}" id="${dynamicId}" class="dynamicContent dynamicContentBorder">${selectedText.textContent}</span>`
        )
        range.insertNode(span[0])
        this.clearSelection()
      }
      let dynamicListTemp = JSON.parse(JSON.stringify(this.options.dynamicList))
      dynamicListTemp.push(dynamicData)
      this.$changeOptionsEV(dynamicListTemp, "dynamicList", false, undefined, this.myid, true)
      this.showSettingDialog = false
    },
    clearSelection() {
      if (document.selection) {
        document.selection.empty()
      } else if (window.getSelection) {
        window.getSelection().removeAllRanges()
      }
    },
    // 初始化富文本内容
    initRichTextContentHandle() {
      // 先判断默认数据中是否存在ast属性, 初始化逻辑文本组件内容，dom转换成ast,并存储ast数据结构替代content
      if (!this.options.ast) {
        this.initDom = `<div id="root-${this.myid.rect_id}"><p>${this.options.content}</p></div>`
        const ast = parseAST(this.initDom)
        this.$changeOptionsEV(ast, "ast", false, undefined, this.myid, true)
      } else {
        let parent = document.createElement("div")
        const dom = parseDOM(this.options.ast)
        parent.appendChild(dom)
        this.initDom = parent.innerHTML
      }
    },
    // 初始化富文本中变量和动态数据的mouse事件
    initRichTextEventHandle() {
      const self = this
      if (!!self.initDom) {
        for (let i = 0; i < self.options.variableDataList.length; i++) {
          const variableDataItem = self.options.variableDataList[i]
          const variableId = variableDataItem.variableValue
          const dom = document.getElementById(variableId)
          if (!!variableId && !!dom) {
            let variableMouseenterListener
            if (variableId !== this.logicTextDynamicId) {
              variableMouseenterListener = listenNode(dom, "mouseenter", function () {
                self.showTooltip(this, variableDataItem.variableLabel, "variable", "")
              })
              variableMouseenterListener = listenNode(dom, "mouseleave", function () {
                self.closeTooltip(this, variableId, "variable")
              })
            }
            const variableClickBind = this.variableClick(variableId, variableDataItem)
            this.variableDomList.push([dom, variableClickBind])
            dom.addEventListener("click", variableClickBind)
          }
        }
        for (let j = 0; j < self.options.dynamicList.length; j++) {
          const dynamic = self.options.dynamicList[j]
          const dynamicId = dynamic.value
          const dom = document.getElementById(dynamicId)
          if (!!dynamicId && !!dom) {
            let dynamicMouseenterListener
            if (dynamicId !== this.logicTextDynamicId) {
              dynamicMouseenterListener = listenNode(dom, "mouseenter", function () {
                self.showTooltip(this, dynamic.label, "dynamic", "")
              })
              dynamicMouseenterListener = listenNode(dom, "mouseleave", function () {
                self.closeTooltip(this, dynamicId, "dynamic")
              })
            }
            const dynamicClickBind = this.dynamicClick(dynamicId, dynamic)
            this.dynamicDomList.push([dom, dynamicClickBind])
            dom.addEventListener("click", dynamicClickBind)
          }
        }
      }
    },
    showTooltip(obj, content, type, id) {
      const oRect = obj.getBoundingClientRect()
      const containerRect = this.$refs.textInner.getBoundingClientRect()
      if (type === "variable") {
        if (this.variableParams.id && this.variableParams.id === id) return
        this.variableParams.isShow = true
        this.variableParams.name = content
        this.variableParams.style.left = oRect.left - containerRect.left + "px"
        this.variableParams.style.top = oRect.top - containerRect.top - 20 + "px"
        obj.style.background = "rgba(255, 0, 199, 0.24)"
        if (id) {
          this.variableParams.id = id
        }
      } else {
        if (this.dynamicParams.id && this.dynamicParams.id === id) return
        this.dynamicParams.isShow = true
        this.dynamicParams.name = content
        this.dynamicParams.style.left = oRect.left - containerRect.left + "px"
        this.dynamicParams.style.top = oRect.top - containerRect.top - 20 + "px"
        obj.style.background = "rgba(36, 0, 255, 0.24)"
        if (id) {
          this.dynamicParams.id = id
        }
      }
    },
    closeTooltip(obj, id, type) {
      if (type === "variable") {
        if (this.variableParams.id !== id) {
          this.variableParams.isShow = false
          obj.style.background = ""
        }
      } else {
        if (this.dynamicParams.id !== id) {
          this.dynamicParams.isShow = false
          obj.style.background = ""
        }
      }
    },
    onSelectionChange() {
      const $this = this
      const currentTarget = document.getElementById(
        "logicTextContent-" + $this.ids.container_id + "-" + $this.ids.rect_id
      )
      if (
        $this.ids.container_id === $this.myid.container_id &&
        $this.ids.rect_id === $this.myid.rect_id &&
        currentTarget &&
        currentTarget.getAttribute("contenteditable") === "true"
      ) {
        if ($this.$store.state.states.elementType == "cxLogicText") {
          const sel = window.getSelection && window.getSelection()
          if (sel && sel.rangeCount > 0) {
            const oRange = sel.getRangeAt(0)
            const oRect = oRange.getBoundingClientRect()
            const containerRect = $this.$refs.textInner?.getBoundingClientRect()
            if (!!containerRect) {
              if (oRange.toString().length > 0) {
                $this.showSettingDialog = true
              } else {
                $this.showSettingDialog = false
              }
              /**
               * ".setDynamic_dialog"弹窗在"ref-textInner"中是相对定位，需要用两者getBoundingClientRect()绝对位置求差计算除相对位置，
               * left需要加上选中文本width的一半，再减去弹窗宽度的一半34px
               * top需要减去选中文本的行高再减去弹窗与选中文本的间距10px
               */
              let actualLineHeight = $this.options.lineHeight
              if ($this.options.lineHeightType === '%') {
                actualLineHeight = $this.options.fontSize * ($this.options.lineHeight / 100)
              } else if(this.options.lineHeightType === 'normal'){
                // 由于此时取不到文本的实际行高，所以采用通常normal大约是1.2到1.5倍的字体大小规则，此时取最大值
                actualLineHeight = $this.options.fontSize * 1.5
              }
              $this.settingDialogPosition.left = oRect.left - containerRect?.left + oRect.width / 2 - 34 + "px"
              $this.settingDialogPosition.top = oRect.top - containerRect?.top - actualLineHeight - 10 + "px"
            }
          }
        }
      }
    },
    variableClick(variableId, variableDataItem) {
      return e => {
        Array.from(document.getElementsByClassName("dynamicContent")).forEach(item => {
            item.style.background = ""
        })
        Array.from(document.getElementsByClassName("variableContent")).forEach(item => {
          item.style.background = ""
        })
        this.dynamicParams.isShow = false
        const el = e.target
        el.style.background = "rgba(255, 0, 199, 0.24)"
        this.showTooltip(el, variableDataItem.variableLabel, "variable", variableId)
        this.$store.commit("states/changeLogicTextDynamicId", variableId)
      }
    },
    dynamicClick(dynamicId, dynamic) {
      return e => {
        Array.from(document.getElementsByClassName("dynamicContent")).forEach(item => {
            item.style.background = ""
        })
        Array.from(document.getElementsByClassName("variableContent")).forEach(item => {
          item.style.background = ""
        })
        this.variableParams.isShow = false
        const el = e.target
        el.style.background = "rgba(36, 0, 255, 0.24)"
        this.showTooltip(el, dynamic.label, "dynamic", dynamicId)
        this.$store.commit("states/changeLogicTextDynamicId", dynamicId)
      }
    },
    variableToolBoxClick(e) {
      e.stopPropagation()
      const id = this.variableParams.id
      document.getElementById("tab-second")?.click()
      setTimeout(function () {
        document.getElementById(id + "-setting")?.click()
        setTimeout(function () {
          document.getElementById(id + "-setting-data")?.click()
        }, 100)
      }, 100)
    },
    dynamicToolBoxClick(e) {
      e.stopPropagation()
      const id = this.dynamicParams.id
      let dynamicListTemp = JSON.parse(JSON.stringify(this.options.dynamicList))
      dynamicListTemp = dynamicListTemp.filter(item => item.value !== id)
      this.$changeOptionsEV(dynamicListTemp, "dynamicList", false, undefined, this.myid, true)
      let variableDataListTemp = JSON.parse(JSON.stringify(this.options.variableDataList))
      for (let i = 0; i < variableDataListTemp.length; i++) {
        const conditionListTemp = variableDataListTemp[i].conditionList
        for (let j = 0; j < conditionListTemp.length; j++) {
          if (conditionListTemp[j].dynamicValue === id) {
            conditionListTemp[j].dynamicValue = ""
            conditionListTemp[j].dynamicLabel = ""
          }
        }
      }
      this.$changeOptionsEV(variableDataListTemp, "variableDataList", false, undefined, this.myid, true)
      const replaceNode = document.getElementById(id)
      replaceNode?.replaceWith(replaceNode.innerHTML.split("<div")[0])
      this.dynamicParams.isShow = false
    },
  }
}
</script>

<style>
.logic-text-component .overflowHidMultiLines {
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.logic-text-component,
.logic-text-component > div {
  transition: transform 0.5s;
}
.logic-text-component > div {
  /*pointer-events: none;*/
}

.logic-text-component ::-webkit-scrollbar {
  width: 8px;
  height: 4px;
}
/* //滚动条的滑块 */
.logic-text-component ::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.logic-text-component .content {
  /*white-space: pre;*/
  height: 100%;
  position: relative;
  z-index: 1001;
}
.logic-text-component .content:focus {
  outline: none;
}
.logic-text-component .edit-content {
  width: 100%;
  height: 100%;
}
.logic-text-component .edit-content textarea {
  width: 100%;
  height: 100%;
  resize: none;
}
.logic-text-component .setDynamic_dialog {
  display: flex;
  position: absolute;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  box-shadow: 0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 9px 28px rgba(0, 0, 0, 0.05),
    0px 12px 48px 16px rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  padding: 4px;
  z-index: 9999;
}
.logic-text-component .variable_btn {
  display: inline-block;
  width: 28px;
  height: 28px;
  background: url("../../../assets/images/variable.png");
  margin-right: 4px;
  cursor: pointer;
}
.logic-text-component .dynamic_btn {
  display: inline-block;
  width: 28px;
  height: 28px;
  background: url("../../../assets/images/dynamic.png");
  cursor: pointer;
}
.logic-text-component .variable_dialog {
  z-index: 9999;
  position: absolute;
  height: 20px !important;
  background: #ff00c7 !important;
  font-weight: 600 !important;
  color: #ffffff !important;
  cursor: pointer;
  border-radius: 2px;
  display: flex;
  align-items: center;
  padding: 1.5px 3px 1.5px 4px;
  font-size: 12px !important;
  line-height: 17px !important;
  font-family: "PingFang SC" !important;
  font-style: normal !important;
  opacity: 1 !important;
}
.logic-text-component .dynamic_dialog {
  z-index: 9999;
  position: absolute;
  height: 20px;
  background: #2400ff !important;
  font-weight: 600 !important;
  color: #ffffff !important;
  cursor: pointer;
  border-radius: 2px;
  display: flex;
  align-items: center;
  padding: 1.5px 3px 1.5px 4px;
  font-size: 12px !important;
  line-height: 17px !important;
  font-family: "PingFang SC" !important;
  font-style: normal !important;
  opacity: 1 !important;
}
.logic-text-component .setting-btn {
  border-left: 1px solid rgba(255, 255, 255, 0.4);
  padding-left: 4px;
}
.logic-text-component .detach-btn {
  border-left: 1px solid rgba(255, 255, 255, 0.4);
  padding-left: 4px;
}
.logic-text-component .variableContentBorder {
  border-bottom: 1px dashed #ff00c7;
}
.logic-text-component .dynamicContentBorder {
  border-bottom: 1px dashed #2400ff;
}
</style>
